import { Col, Divider, Form, Row } from 'antd';
import { FormInstance } from 'antd/lib/form';
import FormListAddRemove from '../../../../common/utils/FormListAddRemove';
import BillingIsDeleted from '../../../Invoice(Visa)/Components/BillingIsDeleted';
import { IInvoiceTourFood } from '../../Types/InvoiceTourTypes';
import FoodForm from './FoodForm';

type Props = {
  form: FormInstance<any>;
  invComClientInfo?: string;
  tourFood?: IInvoiceTourFood[] | undefined;
};

const InvoiceTourFoodForm = ({ form, invComClientInfo, tourFood }: Props) => {
  return (
    <>
      <Form.List name='tourFoods' initialValue={[{}]}>
        {(fields, { add, remove }) =>
          fields.map((field, index) => {
            return (
              <Row key={index} style={{ display: 'flex', alignItems: 'center' }} gutter={[10, 0]}>
                <Col md={23}>
                  <>
                    {index !== 0 ? (
                      <Divider
                        orientation='left'
                        style={{ borderColor: '#44403C' }}
                      >{`Food Information 🥫 #${index + 1}`}</Divider>
                    ) : (
                      ''
                    )}
                    <FoodForm
                      form={form}
                      field={field}
                      invComClientInfo={invComClientInfo}
                      tourFood={tourFood}
                      index={index}
                    />
                  </>
                </Col>
                <Col md={1}>
                  <BillingIsDeleted name={[field.name, 'food_is_deleted']} />
                  <FormListAddRemove
                    add={add}
                    index={index}
                    name={field.name}
                    remove={remove}
                    dataLength={tourFood?.length}
                    form={form}
                    NamePath={['tourFoods', field.name, 'food_is_deleted']}
                  />
                </Col>
              </Row>
            );
          })
        }
      </Form.List>
    </>
  );
};

export default InvoiceTourFoodForm;
